import { getLink } from "../../../utils/utils"

const cite1Text = (
	`Laù opinio de Johan Huizinga, la LUDO povus koncerni sciencon, morojn kaj vivaranĝon, justicon, religion, militon… La LUDO estas libera homa agado, kiu eliras el la kadro de ĉiutaga vivo kaj ne eblas sen reguloj. Lingvon li ne menciis, sed tre trafe rimarkis pri reguloj «Nova filozofia enciklopedio» difinas LUDON kiel unu el ĉefaj formoj de memsufiĉa agado, kiu donas al partoprenantoj plezuron kaj ĝojon. Ĝi ankaù estas uzata kiel trejnilo por sportistoj, militistoj… fakte, ĝi ĉeestas en ĉiuj sferoj de materia kaj spirita kulturo.`
)
const cite1 = (
	`<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">[1]</a></acronym></sup>`
)

const content = {
	esp: (
		`
		<p class="mb-2">
			Regule reaperas diskuto: «Ĉu estas facila nia lingvo Esperanto?»
		</p>
		
		<p class="mb-2">
			Sed ĉiam ĝi sin bazas sur unusola kruro: oni pristudas la trajtojn de la LINGVO mem.
		</p>
		
		<p class="mb-2">
			Sed lernas ja lingvon HOMOJ! Kaj oni ja fakte devas esplori tute alian, ŝajne neniam pristuditan flankon de la problemo: ĉu facila por homoj estas la lingvo?
		</p>
		
		<p class="mb-2">
			Kaj tio estas tre interesa demando, se temi pri Esperanto. Oni konstante rezonadas pri klara strukturo de la lingvo, pri sistemeco de vortklasoj, kio ege plifaciligas la lernadon de Esperanto.
		</p>
		
		<p class="mb-2">
			Jes, sed … POR KIUJ plifaciligas?
		</p>
		
		<p class="mb-2">
			Ja plimulto de homoj absolute ne konscias pri ajna lingva strukturo kaj ne komprenas pri vortklasoj. 
			Ili uzas lingvon senkonscie, kiel aĵon. 
			Por ili, ekzemple, TABLO povas esti ligna, ronda, kuireja ktp, sed ili ne povas percepti la VORTON «tablo», kiu havas kiel ecojn singularon, nominativon, substantivon (kaj en certaj lingvoj ankaŭ deklinacion, genron ktp).
		</p>
		
		<p class="mb-2">
			Tiu abstrakta, lingva dimensio ne ekzistas en multaj mensoj, por ĝi simple ne estas loko en ili. 
			Tion bone komprenis B. W. en sia PMEG, kiam li inventis tiujn vortformojn kiel «a-vorto», «o-vorto» ktp, transigante la lingvajn nociojn al aĵa mondo, kie oni povas vidi kaj tuŝi ilin.
		</p>
		
		<p class="mb-2">
			Sed… por legi kaj kompreni PMEG, oni devas jam bone koni la lingvon, kies reguloj estas klarigataj en la libro; do, la magia cirklo, ĉu ne?
		</p>
		
		<p class="mb-2">
			Alia problemo, same tuŝanta la mensojn de lernantoj, estas la kreivo de Esperanto (kion oni formale nomas «skemeco»). 
			Jes, Zamenhof mem pritaksis kiel la plej granda avantaĝo de Esperanto ĝian krean karakteron, aŭ «elpensadon de regula vortfarado». 
			Ajna uzanto povas mem krei vortojn el la pretaj konstruelementoj, kvazaù el infanaj kubetoj kunmeti novajn vortojn. 
			Kaj ajna uzanto povas kompreni la signifon de nova vorto, dismetante ĝin je apartaj vorteroj. 
			Mi ne vane menciis infanajn kubetojn: Esperanto estas 
			LUDO ${cite1}, granda krea ludo de plenpova intelekto, kiu ĝuas sian potencon, kreante novajn vortojn, novajn sencojn, novajn mondojn… 
			Se kognado kaj pensado okazas ene de lingvo, do ankaŭ lingvo mem povas krei novajn terenojn por kogno kaj penso. 
			Kreante vorton, ni kreas ankaŭ la mondon post ĝi. 
			Kaj se ne ŝvebi en empireo, – kia belega mens-disvolviga ludo por komencantoj: mem krei kaj kompreni novajn kunmetitajn vortojn! Kia intelekta ĝuo!
		</p>
		
		<p class="mb-2">
			Sed … por kiuj? 
			Ĉu multaj kapablas akcepti ĝin? Post multjara instruado de Esperanto kaj aliaj fremdlingvoj, kristaliĝis firma konvinko, ke por tre multaj homoj estas pli facile enparkerigi senpense kaj obeeme dekojn da fremdaj vortoj, ol memorfiksi nur unu radikon kaj algoritmon, laŭ kiu oni povas mem krei multnombrajn vortojn. 
			Homoj ne volas aŭ ne povas streĉi la cerbon, serĉi novan agmanieron, se eblas iri laŭ la kutima vojo. 
			Tial ajna nacia lingvo povus esti por multaj lernantoj pli facila ol Esperanto: ĝi ja ne postulas komprenemon, inventemon, kreemon, liberan pensadon, sed nur la konatan manieron, laŭ kiu oni agis dum miljaroj: laŭŝtupan memorfiksadon.
		</p>
		
		<p class="mb-2">
			Do, tiu nekutima trajto de Esperanto povas eĉ forpeli «simplajn homojn», kiuj ne alkutimiĝis al cerbostreĉoj. 
			Jen, vidu: oni promesis al ili «simplan lingvon» – sed mensogis ja, ĝi ne estas «simpla», estas nekutima, en ĝia kadro oni sentas sin maloportune kaj incitite, ĝi postulas ĉiupaŝe kompreni kaj krei. 
			Kompreneble ja, ke tre multaj forkuras de ĝi, seniluziitaj…
		</p>
		
		<p class="mb-2">
			Do, ĉu estas facila nia lingvo Esperanto? Por kreantoj – jes; sed ĉu multas sur la Tero kreantoj? 
			Tial, neniam venos la F. V., kiam la tuta homaro enproprigos Esperanton; tiu procentaĵo, kiu ekzistas nun, estas, verŝajne, la justa procentaĵo de tiuj, kiuj volas kaj povas uzi «nian karan lingvon». Esperanto – ne por ĉiuj.
		</p>

		<ol class="cites mb-3">
			<li id="cite_note1">
				<a href="#cite_ref1">↩</a>
				${cite1Text}
			</li>
		</ol>
		`
	)
}

const itemName = {
	esp: 'Ĉu estas facila nia lingvo Esperanto 2'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}
export default item;